module.exports = __webpack_public_path__ + "img/qq.55be12b7.svg";